import { useCallback, useRef, useMemo } from "react";
import { useAppStateProvider } from "../../../contextProviders/AppStateProvider";
import createTranslator from "../../../util/translationHelper";
import messages from "./translations/messages";
import helper from "./accountSettingsSidebarHelper";

function useAccountSettingsSidebar(props) {
  const { lang, connectionStatus, subscription } = props;
  const BLOCK = useRef("account-settings-sidebar");
  const { appState, updateAppStateLocal } = useAppStateProvider();
  const translate = useMemo(() => createTranslator(messages), []);

  const isOpen = appState?.accountSettingsSidebarOpen || false;
  const isConnected = connectionStatus === helper.CONNECTION_STATUS.CONNECTED;

  const hasSubscription = subscription != null;
  const subscriptionStatus = subscription?.status ?? null;
  const isCancellationPending =
    subscriptionStatus === helper.SUBSCRIPTION_STATUS.CANCELLATION_PENDING;

  const subscriptionChipVariant = useMemo(() => {
    return helper.getSubscriptionChipVariant(subscriptionStatus);
  }, [subscriptionStatus]);

  const subscriptionLabel = useMemo(() => {
    return translate(subscriptionChipVariant);
  }, [subscriptionChipVariant, translate]);

  const planDisplayText = useMemo(() => {
    return helper.getPlanDisplayText(subscription?.billing_frequency, translate);
  }, [subscription?.billing_frequency, translate]);

  const renewalDateText = useMemo(() => {
    if (isCancellationPending) {
      return helper.formatDate(subscription?.cancellation_effective_date, lang);
    }
    return helper.formatDate(subscription?.next_billing_date, lang);
  }, [subscription, isCancellationPending, lang]);

  const handleClose = useCallback(() => {
    updateAppStateLocal({ accountSettingsSidebarOpen: false });
  }, [updateAppStateLocal]);

  const handleDisconnect = useCallback(() => {
    handleClose();
    updateAppStateLocal({ disconnectModalOpen: true });
  }, [handleClose, updateAppStateLocal]);

  const reconnectLink = `/${lang}/qbo-accounting/terms`;

  return {
    BLOCK,
    isOpen,
    isConnected,
    hasSubscription,
    isCancellationPending,
    subscriptionChipVariant,
    subscriptionLabel,
    planDisplayText,
    renewalDateText,
    handleClose,
    handleDisconnect,
    reconnectLink,
    translate,
  };
}

const Hook = {
  useAccountSettingsSidebar,
};

export default Hook;

